import Vue from 'vue'
import { Table } from 'element-ui';

const _Table = Table
// 当Vue将一个配置对象注册成组件的时候,会自动的在配置上面
// 加上属性_Ctor,当再次使用同一个配置对象的时候,因为这个对象上面已经有_Ctor[SuperId]了,那么就会直接返回早已经注册后的
// 组件,导致我们下面的注册代码无效果
/* 这就是上述的Vue源代码
  const cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {})
  if (cachedCtors[SuperId]) {
    return cachedCtors[SuperId]
  }
*/
// 解决方案两个:1.直接让Vue.component...这段注册代码早于Vue.use(ElementUI) 2.执行 delete Table._Ctor后再注册
delete _Table._Ctor
Vue.component(
  _Table.name,
  function(resolve){
    const bindEvents = _Table.methods.bindEvents
    const unbindEvents = _Table.methods.unbindEvents
    Object.assign(_Table.methods,{
      selfPstion() {
        const { scrollLeft, scrollTop, offsetWidth, scrollWidth } = this.bodyWrapper;
        const { headerWrapper, footerWrapper, fixedBodyWrapper, rightFixedBodyWrapper } = this.$refs;
        if (headerWrapper) headerWrapper.scrollLeft = scrollLeft;
        if (footerWrapper) footerWrapper.scrollLeft = scrollLeft;
        if (fixedBodyWrapper) fixedBodyWrapper.scrollTop = scrollTop;
        if (rightFixedBodyWrapper) rightFixedBodyWrapper.scrollTop = scrollTop;
        const maxScrollLeftPosition = scrollWidth - offsetWidth - 1;
        if (scrollLeft >= maxScrollLeftPosition) {
          this.scrollPosition = 'right';
        } else if (scrollLeft === 0) {
          this.scrollPosition = 'left';
        } else {
          this.scrollPosition = 'middle';
        }
      },
      unbindEvents() {
        unbindEvents.call(this)
        this.bodyWrapper.removeEventListener('scroll', this.selfPstion, { passive: true })
        this.bodyWrapper.removeEventListener('mousewheel', this.handleBodyMousewheel,  { passive: false })
      },
      bindEvents() {
        bindEvents.call(this)
        this.bodyWrapper.removeEventListener('scroll', this.syncPostion, { passive: true })
        this.bodyWrapper.addEventListener('scroll', this.selfPstion, { passive: true })
        this.bodyWrapper.addEventListener('mousewheel', this.handleBodyMousewheel,  { passive: false })
      },
      handleBodyMousewheel(event) {
        const fixedWrapper = this.$refs.fixedWrapper
        if (fixedWrapper) {
          const fixedBodyWrapper = fixedWrapper.querySelector('.el-table__fixed-body-wrapper')
          if (fixedBodyWrapper) {
            event.preventDefault()
            fixedBodyWrapper.scrollBy({ left: event.deltaX, top: event.deltaY })
            this.$refs.bodyWrapper.scrollBy({ left: event.deltaX, top: event.deltaY })
          }
        }
      }
    })
    resolve(_Table)
  }
)